
<n-menu ref="menu" @changeVisibility="onChangeVisibilityMenu">
  <n-menu-group :subheader="$t('signatureList.selectAnAssignee')" divider>
    <div class="capped-height" :class="{ 'is-saving': saving }" :aria-busy="saving ? 'true' : null">
      <n-scroller class="n-scroller">
        <n-list-item v-for="user in assignableUsers" :key="user.id" @click="onAssignUser(user.id)">
          <div class="assignee-wrapper">
            <UserAvatar :user="user" size="xs" />
            <p>{{ userFullName(user) }}</p>
            <span v-if="saving && pendingUserId === user.id" class="assignee-loading">
              <n-loading size="s" dark />
            </span>
          </div>
        </n-list-item>
      </n-scroller>
    </div>
  </n-menu-group>
  <n-menu-group v-if="hasAssignedRecipient">
    <n-list-item
      :class="{ 'is-saving': saving }"
      :leadingIcon="saving && !pendingUserId ? undefined : 'trash'"
      :text="$t('signatureList.deleteRecipient')"
      @click="onDeleteRecipient"
    >
      <template #action>
        <span v-if="saving && !pendingUserId" class="assignee-loading"><n-loading size="s" dark /></span>
      </template>
    </n-list-item>
  </n-menu-group>
  <n-menu-group v-if="allowAddRecipient">
    <n-list-item leadingIcon="user-add" :text="$t('signatureList.addNewRecipient')" @click="openAddRecipientModal" />
  </n-menu-group>
  <n-modal-background v-if="showAddRecipientModal" @close="showAddRecipientModal = false">
    <AddRecipient
      @close="showAddRecipientModal = false"
      @back="showAddRecipientModal = false"
      :noBackButton="true"
      @select="onAssignUser"
    />
  </n-modal-background>
  <n-menu-group v-if="!hasAssignedRecipient">
    <div class="assign-all-toggle" @click.stop>
      <span class="assign-all-label">{{ $t('signatureList.mapRecipientToAllUnassigned') }}</span>
      <n-toggle class="assign-all-switch" :value="assignAllUnassigned" size="s" @change="onToggleAssignAll" />
    </div>
  </n-menu-group>
</n-menu>
